import Repository from "./RepositoryLashic";

const resource = "/healthapp";

export default {
  post(part, body) {
    return Repository.post(`${resource}/${part}`, body);
  },
  put(part, body, config) {
    return Repository.post(`${resource}/${part}`, body, {config});
  },
};



// WEBPACK FOOTER //
// ./src/repositories/UserRepository.js